import { render, staticRenderFns } from "./ProductQuestionnaireCard.vue?vue&type=template&id=3f08a8d6&"
import script from "./ProductQuestionnaireCard.vue?vue&type=script&lang=ts&"
export * from "./ProductQuestionnaireCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports